import StorageActions from '@/utils/actions/storage_actions'
import constants from '@/constants/constants'
import axios from 'axios'
import store from '@/store'

// Crear una nueva instancia de axios para el nuevo endpoint
const formslyApi = axios.create({
    baseURL: process.env.VUE_APP_FORMSLY_API_URL
})

const fetchFormData = formID => new Promise((resolve, reject) => {
    axios.post('/getFormData', {
        formID: formID
    })
        .then(resolve)
        .catch(reject)
})

const fetchFormSourceJSON = (formFolderPath, formVersionID) => new Promise((resolve, reject) => {
    StorageActions.getJSONByS3Path(formFolderPath + constants.S3_FORM_FILE_NAME, formVersionID)
        .then(({json}) => resolve(json))
        .catch(reject)
})

const submitForm = (id, formID, publishedVersionID, submissionJSON, zapier_status, webhook_url) => new Promise((resolve, reject) => {
    axios.post('/submitForm', {
        id: id,
        formID: formID,
        publishedVersionID: publishedVersionID,
        rawData: submissionJSON
    })
        .then(response => {
            if (zapier_status === 'true' && webhook_url){
                sendDataToZapier(submissionJSON, webhook_url);
            }
            checkAndSendToIntegrations(formID, id, submissionJSON);

            resolve(response)
        })
        .catch(reject)
})

const sendDataToZapier = (formData, webhook_url) => new Promise((resolve, reject) => {
    const zapierWebhookUrl = webhook_url;
    axios.post(zapierWebhookUrl, formData)
        .then(resolve)
        .catch(reject)
  })

const sendSubmissionMetrics = ({id, formID, started}) => new Promise((resolve, reject) => {
    axios.post('/submissionMetrics', {id, formID, started})
        .then(resolve)
        .catch(reject)
})

const exchangeGoogleCode = (code, formId, userId) => new Promise((resolve, reject) => {
    axios.post(`${process.env.VUE_APP_SST_URL}/integrations/google/auth/code`, {code, formId, userId})
        .then(resolve)
        .catch(reject)
})

const exchangeNotionCode = (code, formId, userId) => new Promise((resolve, reject) => {
    axios.post(`${process.env.VUE_APP_SST_URL}/integrations/notion/auth/code`, {code, formId, userId})
        .then(resolve)
        .catch(reject)
})

const listGoogleSheets = (formId) => new Promise((resolve, reject) => {
    axios.get(`${process.env.VUE_APP_SST_URL}/integrations/google/listSheets/${formId}`)
        .then(resolve)
        .catch(reject)
})

const listNotionDatabases = (formId) => new Promise((resolve, reject) => {
    axios.get(`${process.env.VUE_APP_SST_URL}/integrations/notion/listDb/${formId}`)
        .then(resolve)
        .catch(reject)
})

const createGoogleSheet = (title, userId, formId, displayAnswers, sendExisting, selectedFields) => new Promise((resolve, reject) => {
    axios.post(`${process.env.VUE_APP_SST_URL}/integrations/google/createSheet`, {title, userId, formId, displayAnswers, sendExisting, selectedFields})
        .then(resolve)
        .catch(reject)
})

const sendDataToIntegration = (formId, submissionId, submission) => new Promise((resolve, reject) => {
    axios.post(`${process.env.VUE_APP_SST_URL}/integrations/sendSubmission`, {formId, submissionId, submission})
        .then(resolve)
        .catch(reject)
})

const useGoogleSheet = (spreadsheetId, userId, formId, displayAnswers, sendExisting, selectedFields) => new Promise((resolve, reject) => {
    axios.post(`${process.env.VUE_APP_SST_URL}/integrations/google/useSheet`, {spreadsheetId, userId, formId, displayAnswers, sendExisting, selectedFields})
        .then(resolve)
        .catch(reject)
})

const useNotionDb = (databaseId, formId, displayAnswers, sendExisting, selectedFields) => new Promise((resolve, reject) => {
    axios.post(`${process.env.VUE_APP_SST_URL}/integrations/notion/useDb`, {databaseId, formId, displayAnswers, sendExisting, selectedFields})
        .then(resolve)
        .catch(reject)
})

const getFormIntegrations = (formId) => new Promise((resolve, reject) => {
    axios.get(`${process.env.VUE_APP_SST_URL}/integrations/list/${formId}`)
        .then(resolve)
        .catch(reject)
})

const disconnectFormIntegration = (formId, title) => new Promise((resolve, reject) => {
    axios.post(`${process.env.VUE_APP_SST_URL}/integrations/disconnect/${formId}`, {integrationType: title})
        .then(resolve)
        .catch(reject)
})

const uploadAttachment = (file, fileName) => StorageActions.putObject({file, filePath: constants.S3_UPLOADS_FOLDER_PATH + fileName, contentType: file.type, initialFilename: file.name})

const duplicateForm = formID => new Promise(async (resolve, reject) => {
    try {
        // Obtener el token JWT de Cognito
        const token = await store.dispatch('user/getUserJwtToken');
        formslyApi.post(`/form/${formID}/duplicate`, {}, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
        .then(response => resolve(response.data))
        .catch(error => {
            reject(error);
        });
    } catch (error) {
        reject(error);
    }
})

const disconnectZapier = formID => new Promise((resolve, reject) => {
    axios.delete('/deleteFormWebhook', {
        data: {
            formID: formID
        }
    })
    .then(response => resolve(response.data))
    .catch(error => {
        reject(error);
    });
})

// Nueva función para verificar integraciones activas antes de enviar
const checkAndSendToIntegrations = async (formID, submissionId, submissionJSON) => {
    try {
        const response = await getFormIntegrations(formID);
        const integrations = response.data;
        
        // Verificar si hay al menos una integración activa
        const hasActiveIntegrations = integrations.some(integration => 
            integration.integrationStatus === 'active'
        );
        
        if (hasActiveIntegrations) {
            console.log('📊 Enviando datos a integraciones activas:', integrations.length);
            sendDataToIntegration(formID, submissionId, submissionJSON);
        } else {
            console.log('⏸️ No hay integraciones activas - omitiendo envío');
        }
    } catch (error) {
        console.warn('⚠️ Error al verificar integraciones:', error);
        // En caso de error, no enviar para evitar problemas
    }
}

export default {
    fetchFormData,
    fetchFormSourceJSON,
    submitForm,
    uploadAttachment,
    sendSubmissionMetrics,
    exchangeGoogleCode,
    exchangeNotionCode,
    listGoogleSheets,
    listNotionDatabases,
    createGoogleSheet,
    useGoogleSheet,
    useNotionDb,
    sendDataToIntegration,
    getFormIntegrations,
    disconnectFormIntegration,
    duplicateForm,
    disconnectZapier,
}